<template>
  <vk-modal
      @close="$router.replace({ name: 'pro-public-profile', params: $route.params })">
    <vk-modal-body class="MODAL-BODY">
      <vk-modal-header>
        <div class="d-flex ai-center">
          <vk-icon name="bgcheck" class="h2 c-green m-r-1"/>
          Share Pro
        </div>
      </vk-modal-header>
      <vk-modal-content>
        <div>
          <input :value="url" @click="copy" class="input flex-1-1 m-t-1 cur-pointer" readonly :disabled="disabled">
          <div v-html="copyText" class="m-b-1 c-depot"/>
          <div class="d-flex fd-column:mo">
            <a
                :href="`https://www.facebook.com/sharer/sharer.php?u=${url}`"
                target="_blank"
                rel="noopener noreferrer"
                class="FACEBOOK-LINK link flex-1-1 m-b-2:mo m-r-2:t"/>
            <a
                :href="`https://twitter.com/share?url=${url}`"
                target="_blank"
                rel="noopener noreferrer"
                class="TWITTER-LINK link flex-1-1"/>
          </div>
        </div>
      </vk-modal-content>
    </vk-modal-body>
  </vk-modal>
</template>

<script>
export default {
  name: 'share-modal',
  data () {
    return {
      url: '',
      isCopied: false,
      disabled: false,
    };
  },
  computed: {
    copyText () {
      return this.isCopied ? 'Copied to clipboard' : '<br>';
    },
  },
  mounted () {
    this.url = window.location.href.replace('/share', '');
  },
  methods: {
    async copy () {
      try {
        await navigator.clipboard.writeText(this.url);
        this.isCopied = true;
        this.disabled = true;
        setTimeout(() => {
          this.isCopied = false;
          this.disabled = false;
        }, 1500);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .MODAL-BODY {
    @include tablet {
      width: 700px!important;
    }
  }

  .FACEBOOK-LINK {
    display: block;
    background: url('./assets/facebook-button.svg') center / cover no-repeat;
    height: 50px;
  }

  .TWITTER-LINK {
    display: block;
    background: url('./assets/twitter-button.svg') center / cover no-repeat;
    height: 50px;
  }
</style>
